import SearchIcon from "@/components/icons/SearchIcon"
import { useAppSelector } from "@/lib/redux/hooks"
import { checkIsValidInputFlights } from "@/utils/flight/checkIsValidInputFlights"
import { getQueryStringSearchFlight } from "@/utils/string/getQueryStringSearchFlight"
import { Button } from "antd"
import { toast } from 'react-toastify';
import { useTERouter } from "@/hooks/app/useTERouter"
import { useTranslation } from "react-i18next"
import { useTransition } from "react"

type ButtonSubmitSearchFlightsProps = {
  hero?: boolean
}

const ButtonSubmitSearchFlights = ({ hero = false }: ButtonSubmitSearchFlightsProps) => {
  const router = useTERouter()
  const { t } = useTranslation()
  const inputFlights = useAppSelector(state => state.flight.inputFlights)
  const [isSearching, startSearchTransition] = useTransition()
  const selectedInputFlightIndex = useAppSelector(state => state.flight.selectedFligthInputIndex)
  const selectedInputFlight = useAppSelector(state => state.flight.inputFlights[selectedInputFlightIndex])

  return (
    <Button
      className={hero ? "home__searching--hero-search-btn" : undefined}
      onClick={() => {
        if (inputFlights.length < 1) {
          return;
        }
        if (!selectedInputFlight?.toAirport) {
          toast.error(t("flight.airport_to_required"))
          return;
        }
        if (!selectedInputFlight?.fromAirport) {
          toast.error(t("flight.airport_from_required"))
          return;
        }
        const isValidInput = checkIsValidInputFlights()
        if (isValidInput) {
          startSearchTransition(() => {
            router.push(`/flights/result?${getQueryStringSearchFlight()}`)
          })
        } else {
          toast(t("flight.invalid_input"), {
            type: 'warning'
          })

        }
      }}
      loading={isSearching}
      disabled={isSearching}
      block={!hero}
      type='primary'
      size={hero ? 'middle' : 'large'}
      icon={<SearchIcon style={{ fontSize: hero ? '1.6rem' : '3rem' }} />}
    >
      {t("flight.search_flights")}
    </Button>
  )
}

export default ButtonSubmitSearchFlights